import styled, { keyframes } from "styled-components";

const loaderAnimation = keyframes`
  0% { transform: scale(.8)}
  50% {transform: scale(1)}
  100% {transform: scale(.8)}
`;

export const Loader = styled.svg`
  animation-name: ${loaderAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  min-height: 506px;
`;
